export enum ELegalLinks {
  TERMS_OF_USE = 'https://www.spoton.com/legal/user-terms',
  PRIVACY_POLICY = 'https://www.spoton.com/legal/consumer-privacy',
  ACCESSIBILITY_STATEMENT = 'https://www.spoton.com/legal/accessibility-statement',
}
